import { defaultTo } from 'aa_common/front-end/helpers'
import { useWatch } from 'react-hook-form'

import { FIELD_NAMES } from '../validation'

export const useRemainBookValue = (bookValue: number) => {
  const impairedAmount = defaultTo(useWatch<number>({ name: FIELD_NAMES.impaired_amount }), 0)

  return Math.max(bookValue - impairedAmount, 0)
}
